<div class="container">

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>newspaper</mat-icon>
				<span>News</span>
			</div>

			@if( bLoadingNews ) {
				<mat-spinner diameter=30 />
			}

		</div>

		<div>

			@if( !bLoadingNews ) {

				@if( news.length ) {

					<div>

						@for( oNews of news; track oNews.id ) {
							<app-news-display
								[news]="oNews"
								[bShowRelease]="false"
							/>
						}
		
						<div style="margin: 1em;">
							<a
								class="linkMore"
								[routerLink]="['/News']"
								title="News"
							>
								Mehr sehen…
							</a>
						</div>

					</div>
					
				}
				@else {

					<div class="noElements">
						In den Rubriken, die Sie abonniert haben, gibt es keine Neuigkeiten
					</div>
		
				}

			}

		</div>

	</div>

	<div class="portalCard">

		<div class="rowScreenColPhone">

			<div class="aTitle">
				<mat-icon>event</mat-icon>
				<span>Veranstaltungen</span>
			</div>

			@if( bLoadingEvents ) {
				<mat-spinner diameter=30 />
			}

		</div>

		@if( !bLoadingEvents ) {

			<div>
				@for( event of events; track event.id ) {

					<div class="eventLine">
		
						<div class="eventText" (click)="eventClicked(event)">
							<span> {{ event.tmsStart | date: "dd.MM.YYYY HH:mm" }} </span>
							<span class="eventName"> {{ event.name }} </span>
						</div>
		
						@if( bAdmin ) {
							<span
								(click)="clickEditEvent( event.id )"
								class="material-icons customBtn"
								title="Bearbeiten"
							>
								edit
							</span>
						}
			
					</div>

				}

				@if( !events.length ) {
					<div class="noElements">
						In den Gruppen, die Sie abonniert haben, gibt es keine Veranstaltungen
					</div>
				}
	
				<div class="eventLine">
					<a
						class="linkMore"
						[routerLink]="[ '/Veranstaltungen' ]"
						[state]="{ bList: true }"
						(click)="onMoreSeeEvents()" 
						title="Veranstaltungen"
					>
						Mehr sehen…
					</a>
				</div>
	
			</div>

		}

	</div>

	@if( bExchange ) {

		<div class="portalCard">
	
			<div class="rowScreenColPhone">
	
				<div class="aTitle">
					<mat-icon>mark_email_unread</mat-icon>
					<span>Ungelesene Benachrichtigungen</span>
				</div>
	
				@if( bLoadingDocuments ) {
					<mat-spinner diameter=30 />
				}
	
			</div>
	
			@if( !bLoadingDocuments ) {

				<div>
	
					@if( unreadDocumentExchanges.length ) {
		
						<div class="gridDocumentExchange">
		
							@for( documentExchange of unreadDocumentExchanges; track documentExchange.id ) {
		
								<div class="mobileBorder">
									{{ documentExchange.date | date: 'dd.MM.YYYY HH:mm' }}
								</div>
								
								<div class="eventName">
									{{ documentExchange.description }}
								</div>
									
								<div class="mobileGridSpan">
									@for( f of documentExchange.files; track f.id ) {
										<div>
											<span
												class="fileLink"
												(click)="downloadFile( f, documentExchange )"
											>
												{{f.filename}}
											</span>
										</div>
									}
								</div>
							}
			
						</div>
				
					}
					@else {
						<div class="noElements">
							Sie haben keinen ungelesenen Austausch
						</div>
					}
	
					<div class="eventLine">
						<a class="linkMore" [routerLink]="['/Austausch']" title="Austausch">
							Mehr sehen…
						</a>
					</div>
	
				</div>

			}
	
		</div>

	}

</div>
